import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=6a3af008&"
import script from "./configurator.vue?vue&type=script&lang=ts&"
export * from "./configurator.vue?vue&type=script&lang=ts&"
import style0 from "./configurator.vue?vue&type=style&index=0&id=6a3af008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports